<template>
  <div class="mt-4 pr-7"
    name="schoolYear">
    <ValidationProvider rules="required" name="school year" v-slot="{ errors }">
      <SelectionField
        v-model="formValues.schoolYearSelect"
        :options="schoolYearOptions"
        :disabled="!enableSchoolYearSelection"
        :defaultValue="defaultValue"
        @input="updateValue()"
      >
        School Year
      </SelectionField>
      <span
        class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
        name="error-text">
        {{ errors[0] }}
      </span>
    </ValidationProvider>
    <!--FormulateInput
      label="School Year"
      name="schoolYearSelect"
      type="select"
      validation="^required"
      :disabled="!enableSchoolYearSelection"
      :options="schoolYearOptions"
      :value="schoolYearSelect"
    -->
  </div>
</template>

<script>
import DROPDOWN_LISTS from '../components/DropdownLists.json'
import SelectionField from './formComponents/SelectionField.vue'
import { isString } from 'lodash'

export default {
  components: { SelectionField },
  props: {
    enableSchoolYearSelection: Boolean,
    disableDefaultValueUpdates: Boolean,
    defaultValue: undefined,
    options: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formValues: {schoolYearSelect: '', },
      schoolYearOptions: DROPDOWN_LISTS.schoolYears,
      schoolYearSelect: -1,
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.formValues.schoolYearSelect);
    },
    setDefault() {
      if (this.options !== undefined) {
        this.schoolYearOptions = this.options
      }
      else {
        this.schoolYearOptions = DROPDOWN_LISTS.schoolYears
      }

      if (this.defaultValue === undefined) {
        return
      }

      if (!this.checkSchema(this.defaultValue)) {
        return
      }

      if (this.disableDefaultValueUpdates) {
        return
      }
      this.formValues.schoolYearSelect = this.defaultValue
      this.updateValue('schoolYearSelect', this.formValues.schoolYearSelect)

      this.$emit('defaultValueUsed')
    },
    checkSchema(obj) {
      if (!isString(obj)) {
        console.warn(`Invalid default value data type in SchoolYear, ${typeof obj}`)
        return false
      }

      return true
    }
  },
  mounted() {
    this.setDefault()
  },
  watch: {
    defaultValue() {
      this.setDefault()
    },
    options() {
      this.setDefault()
    }
  }
}
</script>
